export const ACTION_LEAD_FORM = "lead-form"

export const URL_MAPPINGS = {
  "shop": "/vehicles",
  "trade": "/trade",
  "new-cars": "/vehicles/new",
  "used-cars": "/vehicles/pre-owned",
  "certified": "/vehicles/certified",
  "new-cars-count": "/vehicles/new",
  "used-cars-count": "/vehicles/pre-owned",
  "brands-count": "/dealerships",
  "dealerships-count": "/dealerships",
  "about": "/dealerships",
  "dealers": "/dealerships",
  "lead-form": "function",
  "trade-form": "function",
  "favorites": "function",
  "budget": "function",
  "location": "function",
  "about-us": "/about-us",
  "opt-out": "/opt-out",
  "commercial": "/commercial",
}
